import {
  MyCafeteriaAdminSettingsPage,
  MyCafeteriaPage,
  MyCafeteriaSzepCardApplicationPage,
  MyCafeteriaVbkApplicationPage,
} from "my-cafeteria/pages";

export const MyCafeteriaPageRoutePath = "/my-cafeteria";
export const myCafeteriaVbkApplicationPageRoutePath =
  "/my-cafeteria/vbk-application";
export const myCafeteriaSzepCardApplicationPageRoutePath =
  "/my-cafeteria/szep-card-application";
export const myCafeteriaAdminSettingsPageRoutePath =
  "/my-cafeteria/admin/settings";

export const myCafeteriaRoutes = [
  {
    id: "myCafeteriaPageRoute",
    path: MyCafeteriaPageRoutePath,
    exact: true,
    private: true,
    component: MyCafeteriaPage,
    roles: ["MyCafeteria.user"],
  },
  {
    id: "myCafeteriaVbkApplicationPage",
    path: myCafeteriaVbkApplicationPageRoutePath,
    exact: true,
    private: true,
    component: MyCafeteriaVbkApplicationPage,
    roles: ["MyCafeteria.user"],
  },
  {
    id: "myCafeteriaSzepCardApplicationPage",
    path: myCafeteriaSzepCardApplicationPageRoutePath,
    exact: true,
    private: true,
    component: MyCafeteriaSzepCardApplicationPage,
    roles: ["MyCafeteria.user"],
  },
  {
    id: "myCafeteriaAdminSettings",
    path: myCafeteriaAdminSettingsPageRoutePath,
    exact: true,
    private: true,
    component: MyCafeteriaAdminSettingsPage,
    roles: ["MyCafeteria.admin"],
  },
];
